module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro--chf-8761178e22ca9dcf1cb4b99ec817369b.jpg";